import type { ReactNode } from 'react';

interface TileCardProps {
  /** 上半的圖示區內容（SVG 或 emoji）。 */
  icon: ReactNode;
  title: string;
  sub?: string;
  onClick: () => void;
  /** 圖示區高度 px；attract 的兩張大卡比主功能四格高。 */
  iconHeight?: number;
}

/**
 * 圖文卡 — 設計稿 p.4／p.5 的共用形制：上半圖示區、金色虛線、下半標籤區。
 *
 * attract 的「觸碰開始／語音互動」與主功能的 2×2 四格是同一種卡，差別只在尺寸，
 * 所以共用一個元件——兩邊各刻一次的話，日後調圓角或虛線只會改到其中一邊。
 */
export function TileCard({
  icon,
  title,
  sub,
  onClick,
  iconHeight = 200,
}: TileCardProps): JSX.Element {
  return (
    <button type="button" className="k-tile" onClick={onClick}>
      <span className="k-tile__icon" style={{ height: iconHeight }} aria-hidden="true">
        {icon}
      </span>
      <span className="k-tile__labels">
        <span className="k-tile__title">{title}</span>
        {sub !== undefined && <span className="k-tile__sub">{sub}</span>}
      </span>
    </button>
  );
}
